import React from 'react';
import {doShowInformer} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export default class Layout extends React.PureComponent {
    static defaultProps = {
        showCloseButton: true,
        filtered: false
    };

    onClose = () => {
        const {externalKey, onClose} = this.props;
        onClose(externalKey);
    };

    render() {
        const {component: Component, showCloseButton, filtered, filter, ...props} = this.props;

        if (filtered && !doShowInformer(filter)) {
            return null;
        }

        return (
            <div className="notification__item">
                {showCloseButton && <button className="act notification__close" onClick={this.onClose}>
                    <SpriteIcon name="#svg-close" size={{height: 10, width: 10}}/>
                </button>}

                <Component {...props} onClose={this.onClose}/>
            </div>
        );
    }
}
